export default "__VITE_ASSET__DE$ClZg___"